// extracted by mini-css-extract-plugin
export default {"modal__wrap":"Modal_modal__wrap__ce02v","visible":"Modal_visible__WagnM","modal":"Modal_modal__Y8V-K"};